// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"Loader_spinnerWrapper__bBAhS","loaderLogo":"Loader_loaderLogo__XGOH0"};